import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const hepatitis: AnswerPathTreeNode = {
  path: 'hepatitis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredHepatitisDetails }],
};
